const config = require("../config")

module.exports = {
    farmWorkPlan: {
        url: config.base_dev_url + "container_space_time/farmWorkPlan",
        type: "get",
    },
    //添加复核照片
    addReviewImg: {
        url: config.base_dev_url + "z_farm_work_record/addReviewImg",
        type: "post",
    },
    //根据containerSpaceTimeId查询物候期列表
    listPhenology: {
        url: config.base_dev_url + "container_space_time/listPhenologyByContainerSpaceTimeId",
        type: "get",
    },
    //更新农事编排信息
    updateFarmWorkArrange: {
        url: config.base_dev_url + "container_farm_work_arrange/save",
        type: "post",
    },
    // 批量验证多个农事药肥报价信息是否完整
    batchValidatePesticideFertilizerQuotes: {
        url: config.base_dev_url + "z_farm_work_lib/batchValidatePesticideFertilizerQuotes",
        type: "post",
    },
    //获取物候列表
    getPhenologyList: {
        url: config.base_new_url + "farm_works",
        type: "get",
    },
    //农场互动信息
    getFarmRiskAndTracking: {
        url: config.base_new_url + "farm_risk_and_tracking",
        type: "get",
    },
    //获取农事详情
    getWorkDetail: {
        url: config.base_new_url + "find_farm_work",
        type: "get",
    },
    //获取物候节点信息
    getFindPhenologyInfo: {
        url: config.base_new_url + "find_phenology_info",
        type: "get",
    },
    //校准物候期
    farmPhenologyAdjust: {
        url: config.base_new_url + "farm_phenology_adjust",
        type: "post",
    },
    //临时：分区相册图片
    getRegionAlbumImages: {
        url: config.base_dev_site_url + "adm/images/{organId}/{areaId}?key=" + config.mini_key,
        type: "get",
    },
};